__turbopack_context__.v({
  "features": "_6r9y0a_features",
  "featuresactive": "_6r9y0a_featuresactive",
  "svg": "_6r9y0a_svg",
  "text3": "_6r9y0a_text3",
  "text3active": "_6r9y0a_text3active",
});
